<div class="card border-0 shadow-sm h-100">
    <div class="card-body">
        <div class="d-sm-flex justify-content-center align-items-center mb-4">
            <h4 class="mb-0 text-secondary">{{ title }}</h4>
        </div>
        <dx-pie-chart
            type="doughnut"
            [dataSource]="chartItems"
            [innerRadius]="0.7"
            centerTemplate="centerTemplate"
            [customizePoint]="customizePoint">
            <dxi-series argumentField="argument" valueField="value">
                <dxo-label [visible]="false"></dxo-label>
            </dxi-series>
            <dxo-tooltip [enabled]="hasData" [customizeTooltip]="customizeTooltip"></dxo-tooltip>
            <dxo-legend
                [customizeItems]="customizeLegendItems"
                horizontalAlignment="center"
                verticalAlignment="bottom"
                [rowItemSpacing]="10"
                [columnItemSpacing]="20"
                [markerSize]="14"
                markerTemplate="markerTemplate">
            </dxo-legend>
            <svg *dxTemplate="let pieChart of 'centerTemplate'">
                <text text-anchor="middle"
                      style="font-size: 32px; fill: currentColor; font-weight: 600;"
                      x="100" y="100">
                    <tspan x="100" dy="0">{{ centerValue }}</tspan>
                    <tspan class="text-body-secondary"
                           x="100" dy="22"
                           style="font-size: 13px; fill: currentColor; font-weight: normal;">{{ centerText }}</tspan>
                </text>
            </svg>
            <svg *dxTemplate="let legend of 'markerTemplate'">
                <circle cx="10" cy="10" r="10" [attr.fill]="getMarkerColor(legend)"></circle>
            </svg>
        </dx-pie-chart>
    </div>
</div>
